import React, { useContext, lazy, Suspense } from 'react'
import styled from 'styled-components'
import { useWindowScroll, useToggle, useClickAway } from 'react-use'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyContext } from '../../context'
import Logo from './Logo'
import Menu from './Menu'
import AliyunMail from './AliyunMail'
import Hamburger from './Hamburger'
import FullScreen from './FullScreen'
import Mail from './Mail'

const HeaderWraper = styled.header`
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  width: 100%;
  z-index: 10000;
  transition: all 0.3s ease-in-out;
  background-color: ${({ y, fade, theme }) =>
    fade && y < 100 ? '#0058a930' : theme.colors.primary};
  box-shadow: ${({ y }) => (y > 100 ? '0px 3px 9px rgba(0,0,0,0.1)' : 'none')};
  @media (max-width: 768px) {
    /* flex-direction: column; */
    height: 60px;
    width: 100%;
  }
`
const HeaderContainer = styled.div`
  /* width: ${(props) => props.theme.containerWidth}; */
  width: 100%;
  height: 100px;
  display: flex;
  padding: 0 50px;
  position: relative;
  /* justify-content: space-between; */
  align-items: center;
  .space {
    flex: 1;
  }
  .fullScreen {
    display: block;
  }
  .toggleMenu {
    display: none;
  }

  @media (max-width: 768px) {
    /* flex-direction: column; */
    height: 60px;
    /* width: 100%; */
    padding: 0;
    .fullScreen {
      display: none;
    }
    .toggleMenu {
      display: block;
    }
  }
`
const RowWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  .space {
    flex: 1;
  }
  @media (max-width: 768px) {
    height: 60px;
    /* width: 100%; */
  }
`
const Header = ({ fade }) => {
  const { strapiHome } = useStaticQuery(graphql`
    {
      strapiHome {
        urlOA
        urlMail
      }
    }
  `)
  const { urlOA, urlMail } = strapiHome
  const { isFullscreenOpen, handleFullscreen } = useContext(GatsbyContext)
  const [on, toggle] = useToggle(false)
  const { y } = useWindowScroll()

  return (
    <HeaderWraper y={y} fade={fade}>
      <HeaderContainer>
        <RowWrap>
          <Logo />
        </RowWrap>
        <div className="space"></div>
        <Menu status={on} y={y} toggle={toggle} />
        {/* <OA url={urlOA} /> */}
        <Mail url={urlMail} />
        {/* <AliyunMail /> */}
        <div className="fullScreen">
          <Hamburger
            handleStatus={handleFullscreen}
            status={isFullscreenOpen}
          />
        </div>
        <div className="toggleMenu">
          <Hamburger handleStatus={toggle} status={on} />
        </div>

        <FullScreen />

        {/* <FullScreen
          handleStatus={handleFullscreen}
          status={isFullscreenOpen}
        /> */}
      </HeaderContainer>
    </HeaderWraper>
  )
}

export default Header
